import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

export default function PaymentCancel() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.colors.bgPrimary,
      padding: '20px',
    }}>
      <Card>
        <div style={{
          padding: '60px 40px',
          textAlign: 'center',
          maxWidth: '500px',
        }}>
          {/* Cancel Icon */}
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 32px',
            fontSize: '40px',
          }}>
            ⚠️
          </div>

          <h1 style={{
            fontSize: '32px',
            fontWeight: 700,
            color: theme.colors.textPrimary,
            marginBottom: '16px',
          }}>
            Payment Cancelled
          </h1>

          <p style={{
            fontSize: '18px',
            color: theme.colors.textSecondary,
            marginBottom: '32px',
            lineHeight: 1.6,
          }}>
            Your payment was cancelled. No charges were made to your account.
          </p>

          <div style={{
            background: theme.colors.bgSecondary,
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '32px',
          }}>
            <p style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              margin: 0,
              lineHeight: 1.6,
            }}>
              If you encountered any issues during checkout or have questions about our pricing, please don't hesitate to contact us. We're here to help!
            </p>
          </div>

          <Button
            variant="primary"
            onClick={() => navigate('/pricing')}
            style={{ width: '100%', marginBottom: '12px' }}
          >
            Try Again
          </Button>

          <Button
            variant="secondary"
            onClick={() => navigate('/home')}
            style={{ width: '100%' }}
          >
            Back to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
